import { styled } from '@mui/material';

import LoaderIcon from '~/assets/icons/svgs/loader.svg?react';

export const StyledCustomLoader = styled(LoaderIcon)({
  animation: 'spin 2s infinite linear',
  '@keyframes spin': {
    '0%': {
      transform: 'rotate(0deg)',
    },
    '100%': {
      transform: 'rotate(360deg)',
    },
  },
});
